import React, { useCallback, useRef } from 'react';
import { IconButton, Theme, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import { FooterPlusDropdownApi } from '../../types';
import { useI18n } from '../../../../lib/hook/useI18n';

const useStyles = makeStyles((theme: Theme) => ({
  trigger: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    padding: 0,
    color: 'var(--text-primary-dark)',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    border: `1px solid ${theme.palette.common.black}`,
  },
  footerPlusDropdownMenu: {
    marginTop: theme.spacing(-1),
  },
  menuItem: {
    padding: theme.spacing(0.75, 2),
    gap: theme.spacing(2),
    minHeight: 'auto',
  },
  menuItemIcon: {
    minWidth: theme.spacing(2.5),
    fontSize: theme.spacing(2),
  },
  menuItemTitle: {
    color: 'var(--text-primary-dark)',
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
  },
  menuItemSubtitle: {
    color: 'var(--text-tertiary-light)',
    fontSize: theme.spacing(1.5),
    lineHeight: '18px',
    marginTop: theme.spacing(0.25),
  },
}));

export const FooterPlusDropdown: React.FC<FooterPlusDropdownApi> = ({
  insertAtContext,
  disabled,
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const classes = useStyles();
  const { t } = useI18n();

  const onAddContext = useCallback(() => {
    insertAtContext();
  }, [insertAtContext]);

  return (
    <>
      <Tooltip
        PopperProps={{ disablePortal: true }}
        placement="top"
        title={
          <span style={{ whiteSpace: 'nowrap' }}>
            {t('buyerCopilot.footer.tagContent')}
          </span>
        }
      >
        <span>
          <IconButton
            ref={anchorRef}
            aria-label="Open options"
            className={classes.trigger}
            onClick={onAddContext}
            size="small"
            disabled={disabled}
          >
            <AddIcon fontSize="inherit" />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
